/**
 * Case state machine from ARCHITECTURE §3.
 *
 * Phase 0 defines the vocabulary only. Transition rules and the engine that
 * enforces them are MD3 — do not add transition logic here ahead of that spec.
 *
 * NEEDS_INFO is a first-class outcome, not an error state: a case may honestly
 * end at "insufficient records to verify" (CLAUDE.md non-negotiable 1).
 */
export const CASE_STATUSES = [
    "DRAFT",
    "SUBMITTED",
    "VALIDATING",
    "NEEDS_INFO",
    "ROUTED",
    "ASSIGNED",
    "SEARCH_IN_PROGRESS",
    "UNDER_REVIEW",
    "OPINION_READY",
    "PACKAGED",
    "DELIVERED",
    "CLOSED",
    "RETENTION_EXPIRED",
];
/**
 * Sri Lanka registers land under two parallel systems and the workflow must
 * handle both (CLAUDE.md §5):
 *  - `deed`  — Registration of Documents; the deed chain is traced manually.
 *  - `title` — Registration of Title Act (Bim Saviya); state-guaranteed title.
 */
export const LAND_SYSTEMS = ["deed", "title"];
//# sourceMappingURL=case.js.map